import React, { useContext, useEffect, useState } from 'react'
import MenuBarComponent from '../Components/MenuBarComponent';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import placePicture from './../images/people_walking.jpg'
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';
import { PiInfo } from 'react-icons/pi';
import { Controller, useForm } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { useNavigate } from 'react-router-dom';
import { listAllReligionsService } from '../Service/ReligionService';
import { Dropdown } from 'primereact/dropdown';
import i18n from '../multilingual/config';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { getReligiousPlaceService, registerReligiousPlaceService, updateReligiousPlaceService } from '../Service/ReligiousPlaceService';
import { toast } from 'react-toastify';
import AuthContext from '../Contexts/AuthContext';
import ReligionsDropdown from '../Components/ReligionsDropdown';
import { Dialog } from 'primereact/dialog';
import ReligiousPlaceDetailsComponent from '../Components/ReligiousPlaceDetailsComponent';

function ReligiousPlaceForm() {
    const {userAuth} = useContext(AuthContext)
    const { t } = useTranslation('register_place');
    const navigate = useNavigate()
    const [allReligions, setAllReligions] = useState()    
    const [isEmailPublic, setIsEmailPublic] = useState(false)
    const [isPhonePublic, setIsPhonePublic] = useState(false)
    const [language, setLanguage] = useState(i18n.language)
    const [placeDetailsAccessKey, setPlaceDetailsAccessKey] = useState()
    const [isDialogVisible, setIsDialogVisible] = useState(false)
    
    useEffect(()=>{
        getReligiousPlaceService(userAuth?.user?.access_key).then(res=>{
            if (res && allReligions){
                setValue('access_key', res.access_key)
                setValue('address', res.address)
                setValue('description', res.description)
                setValue('email', res.email)
                setValue('email_visible', res.email_visible)
                setIsEmailPublic(res.email_visible ? true : false)
                setValue('facebook_url', res.facebook_url)
                setValue('instagram_url', res.instagram_url)
                setValue('lat', res.lat)
                setValue('lng', res.lng)
                setValue('name', res.name)
                setValue('phone', res.phone)
                setValue('phone_visible', res.phone_visible)
                setIsPhonePublic(res.phone_visible ? true : false)
                setValue('tiktok_url', res.tiktok_url)
                setValue('x_url', res.x_url)

                const relIdx = allReligions.findIndex(e=>e.id === res.religion_id)
                setValue('religion', relIdx >= 0 ? allReligions[relIdx] : null)
            }
        })
    },[allReligions])
    
    useEffect(()=>{
        setLanguage(i18n.language)
    },[i18n.language])
    
    useEffect(()=>{
        setValue('email_visible', isEmailPublic)
    },[isEmailPublic])
    
    useEffect(()=>{
        setValue('phone_visible', isPhonePublic)
    },[isPhonePublic])

    useEffect(()=>{
        listAllReligions()
    },[language])

    const {
        register,
        setValue,
        getValues,
        handleSubmit,
        control,
        formState: { errors },
      } = useForm({
        defaultValues: {
            email_visible: false,
            phone_visible: false,
        }
      });

    const sideClassStyle = `flex justify-content-center flex-column-reverse md:flex-row p-2`

    const handleOpenPlaceDetails = (access_key) =>{
        setPlaceDetailsAccessKey(access_key)
        setIsDialogVisible(true)
    }

    const onSubmit = (formData) => {
        if (getValues('access_key')){
            updateReligiousPlaceService({...formData, access_key: getValues('access_key')}).then(res=>{
                if (res.success) {
                    toast.success(t(res.message))
                    navigate('/app/home')
                } else toast.error(t(res.message))
            }).catch(error=>{
                toast.error(t(error.message))
            })
        }else
            registerReligiousPlaceService({...formData, created_by: userAuth?.user?.access_key}).then(res=>{
                if (res) {
                    toast.success(t('register_success'))
                    navigate('/app/home')
                } else toast.error(t('register_failed'))
            }).catch(error=>{
                toast.error(t(error.message))
            })
    }

    const listAllReligions = () => {
        listAllReligionsService(language).then(res=>{
            setAllReligions(res)
        })
    }

    const handleOptionLabel = (e) =>{
        return language === 'pt' ? e.name_pt_br : language === 'es' ? e.name_es : e.name
    }

    const handleAddress = (e) =>{
        const lat = e.geometry?.location?.lat();
        setValue('lat', lat);
        const lng = e.geometry?.location?.lng();
        setValue('lng', lng);
        setValue('address', e.formatted_address);
    }

    const googleMapsOptions = {
        types: ["address"],
        fields: ["address_components", "geometry", "place_id", "formatted_address"],
        strictBounds: false,
    }

    return (
        <div className='flex flex-column gap-4'>
            <Tooltip target={'.is_public_message'} />
            <div className={sideClassStyle}>
                <div className='flex flex-column gap-2 w-full'>
                    <form onSubmit={handleSubmit(onSubmit)} className='flex flex-column gap-2'>
                        <div className='flex flex-column gap-1'>
                            <label>{t('name')}<span className='form-validation-message'>*</span></label>
                            <InputText className='w-full' {...register('name', {
                                required: t('name_validation_message'),
                            })} />
                            {errors.name && <span className='form-validation-message'>{errors.name.message}</span>}
                        </div>
                        
                        <div className='flex flex-column gap-1'>
                            <label>{t('religion')}<span className='form-validation-message'>*</span></label>
                            <Controller
                                name="religion" // Name of the field in the form
                                control={control}
                                rules={{ required: t('religion_validation_message') }} // Validation rule
                                render={({ field }) =>{ 
                                    return (
                                        <ReligionsDropdown field={field} errors={errors} />
                                    )}
                                }
                            />
                            {errors.religion && <span className='form-validation-message'>{errors.religion.message}</span>}
                        </div>
                        
                        <div className='flex flex-column gap-1'>
                            <label>{t('description')}</label>
                            <InputTextarea rows={3} className='w-full' {...register('description')} />
                        </div>
                        
                        <div className='flex flex-column gap-1'>
                            <label>{t('address')}<span className='form-validation-message'>*</span></label>
                            <ReactGoogleAutocomplete defaultValue={getValues('address')} className='w-full p-inputtext p-component' apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} 
                            onPlaceSelected={handleAddress} options={googleMapsOptions} {...register('address', { 
                                required: t('address_validation_message'),
                            })} />
                            {errors.address && <span className='form-validation-message'>{errors.address.message}</span>}
                        </div>
                        
                        <div className='flex gap-2'>
                            <div className='flex flex-1 flex-column gap-1'>
                                <label>{t('phone')}<span className='form-validation-message'>*</span></label>
                                <InputText className='w-full' {...register('phone', {
                                    required: t('phone_validation_message'),
                                })} />
                                {errors.phone && <span className='form-validation-message'>{errors.phone.message}</span>}
                            </div>
                            <div className='flex flex-column gap-1'>
                                <label className='flex gap-1 align-items-center'>
                                    {t('is_public')}
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon"
                                        data-pr-tooltip={t('is_public_message')}
                                        style={{ cursor: 'pointer' }}>
                                        <PiInfo />
                                    </i>
                                </label>
                                <InputSwitch onChange={e=>setIsPhonePublic(e.value)} checked={isPhonePublic} />
                            </div>
                        </div>
                        
                        <div className='flex gap-2'>
                            <div className='flex flex-1 flex-column gap-1'>
                                <label>{t('email')}<span className='form-validation-message'>*</span></label>
                                <InputText className='w-full' {...register('email', {
                                    required: t('email_validation_message'),
                                    pattern: {
                                        value: /^\S+@\S+\.\S+$/,
                                        message: t('email_invalid_message'),
                                    },
                                })} />
                                {errors.email && <span className='form-validation-message'>{errors.email.message}</span>}
                            </div>
                            <div className='flex flex-column gap-1'>
                                <label className='flex gap-1 align-items-center'>
                                    {t('is_public')}
                                    <Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon"
                                        data-pr-tooltip={t('is_public_message')}
                                        style={{ cursor: 'pointer' }}>
                                        <PiInfo />
                                    </i>
                                </label>
                                <InputSwitch onChange={e=>setIsEmailPublic(e.value)} checked={isEmailPublic} />
                            </div>
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('facebook_url')}</label>
                            <InputText className='w-full' {...register('facebook_url')} />
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('instagram_url')}</label>
                            <InputText className='w-full' {...register('instagram_url')} />
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('tiktok_url')}</label>
                            <InputText className='w-full' {...register('tiktok_url')} />
                        </div>

                        <div className='flex flex-column gap-1'>
                            <label>{t('x_url')}</label>
                            <InputText className='w-full' {...register('x_url')} />
                        </div>

                        <div className='flex gap-2 justify-content-center'>
                            <Button type='submit' label={t('save')} className='background-primary' />
                            <Button type='button' label={t('cancel')} className='background-secondary' onClick={()=>navigate('/app/home')} />
                            <Button type='button' icon='pi pi-eye' outlined onClick={()=>handleOpenPlaceDetails(getValues('access_key'))} />
                        </div>
                    </form>
                </div>
            </div>



            <Dialog visible={isDialogVisible} header maximized onHide={()=>setIsDialogVisible(false)}>
                <ReligiousPlaceDetailsComponent access_key={placeDetailsAccessKey} />
            </Dialog>

        </div>
)
}

export default ReligiousPlaceForm